module.exports = __webpack_public_path__ + "img/2025-05-09a_1.839e58c0.jpg";